//import { withRouter } from 'react-router-dom';
import React, { useState, useEffect }  from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap, useMapEvents, LayersControl} from 'react-leaflet';
import { IonLoading, IonToast, useIonViewWillEnter, IonGrid, IonRow, IonContent, IonButton, IonInput, IonLabel, IonCol, IonText, IonItem, IonImg, IonIcon} from '@ionic/react';
import { useHistory } from "react-router-dom";
import { Geolocation, Geoposition } from '@ionic-native/geolocation';
import {Icon} from 'leaflet';
import PhotoGallery from './Photo-gallery';

//Camera Plugin
//import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { usePhotoGallery } from '../../hooks/usePhotoGallery';
import { camera, trash } from 'ionicons/icons';
//import { useFilesystem} from '@ionic/react-hooks/filesystem';

//get geolocation for initial placement
import 'leaflet/dist/leaflet.css';
import 'leaflet/dist/leaflet.js';

import './map.css';

  //colored icons
  const blueIcon = new Icon({
    iconUrl:
      "https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|abcdef&chf=a,s,ee00FFFF",
      iconSize: [25, 41], 
      iconAnchor: [12, 41]
  }),
  greenIcon = new Icon({
    iconUrl:
      "https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|2ecc71&chf=a,s,ee00FFFF",
      iconSize: [25, 41], 
      iconAnchor: [12, 41]
  }),
  orangeIcon = new Icon({
    iconUrl:
      "https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|FF9400&chf=a,s,ee00FFFF",
      iconSize: [25, 41], 
      iconAnchor: [12, 41]
  });

interface LocationError {
    showError: boolean;
    message?: string;
}

export const Map = (
    props: {
        listOfMarkers: any;
        photoGroup: any
        markergroup: any;
        markercolor: any;
        addMarker: any;
        mapCenter: any;
        loadMarkers: any;
        markertotal: any;
        removeFromArray: any;
        updatePosition: any;
        updateContent: any;
        updateMarkers: any;
        setMapCenter: any;
        openLatest: any;
    }) => {

    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<LocationError>({ showError: false });
    const [getposition, setPosition] = useState<Geoposition>();

    const [title, setTitle] = useState<string>();
    const [description, setDescripton] = useState<string>();
    //xconst [getMapCenter, setMapCenter] = useState<any>();
    const [locationchange,setNewLocation] = useState<boolean>(false);

 
    const [getMapLng, setMapLng] = useState<any>(-89.401230);//these should be set dynamically to the center of the map. 
    const [getMapLat, setMapLat] = useState<any>(43.073051);
    
    const [markerTotal, setMarkerTotal] = useState<any>(1);

    const [markerHover, setMarkerHover] = useState<boolean>(false);

    const [longitude, setLong] = useState<number>(-89.401230);
    const [latitude, setLat] = useState<number>(43.073051);

    const [selectField, setSelected]= useState<any>("");
    const [selectText, setTextSelected]= useState<any>("");
    const [selectMarker, setMarkerID]= useState<any>(0);

    const {photos, takePhoto, deletePhoto} = usePhotoGallery();
    
    const [icon, setIcon] = useState(blueIcon);
    const [fileName, setFileName] = useState<any>();
    const [webviewName, setWebviewName] = useState<any>();


    //console.log(props.mapCenter);
    //console.log(props.listOfMarkers.length);
    //console.log("markerTotal",props.markertotal);
   const latlng = "";
    const loadLocation = () => {
        setLong(longitude);
        setLat(latitude);
        setNewLocation(true);
        setLoading(false);
        //setIcon(props.markercolor + 'Icon');
    }
    const getLocation = async () => {
        setNewLocation(true);
        setLoading(true);
        var options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
          };
        try {
            const getposition = await Geolocation.getCurrentPosition(options);
            setPosition(getposition);
            setLong(getposition.coords.longitude);
            setLoading(false);
            setNewLocation(false);
            setError({ showError: false });
            props.setMapCenter(getposition.coords.latitude,getposition.coords.longitude);
            console.log(props.mapCenter,getposition.coords.latitude,getposition.coords.longitude);
            setMapLat(getposition.coords.latitude);
            setMapLng(getposition.coords.longitude);
        } catch (e) {
            setError({ showError: true, message: e.message });
            setLoading(false);
        }
    }
    const history = useHistory();
    function setPhotos(){
        return true;
    }
    function MyComponent(e:any) {
        const map = useMap();
        map.flyTo(props.mapCenter,13);
        //console.log(props);
        //map.setView(props.mapCenter);
        map.invalidateSize();
        const latlng = map.getCenter();
        //var load = props.loadMarkers;
        //console.log(load);
        //load Marker
        //show latest
        if(props.openLatest){
            var mark = props.openLatest;
            //console.log(mark);
            //console.log(mark.d+mark.e);
            //console.log(mark.e);
            //var mapmarker = map.marker([mark.e,mark.d])
            //map.fire('click',{latlng: {lng: mark.e, lat: mark.d}}); //works but causes infinite loop
            //console.log('click', mark.uniqueID);
            //map.openPopup([{mark.e,mark.d}]);
            //map.ref[mark].openPopup();
        }
        var color = props.markercolor;
        if(color === "green"){setIcon(greenIcon);
        }else if(color === "blue"){setIcon(blueIcon);
        }else if(color === "orange"){setIcon(orangeIcon);
        }
        return null;
    }
    function LocationMarker() {
       const map = useMapEvents({
            click(e) {
                setMapLat(e.latlng.lat);
                setMapLng(e.latlng.lng);
                props.setMapCenter(e.latlng.lat,e.latlng.lng);
                //console.log('latlng ',e.latlng.lat,e.latlng.lng);
            }
          })
       return null;
    }
//this?
    ///function updateMarkers(x:any,field:any){
       /// props.listOfMarkers[x]['title'] = field;
        //window.location.reload();
        //console.log("reload");
    ///}
    function setSelectedImage(x:any,y:any,z:any){
        if(x !== "" && y !== "" && z !== ""){
            //make sure that the image data isn't empty
            //i think this is causing
            //console.log("z",z);

            //photos.length = 0;
            //var v;
            if(x){
                //clear out current photos
               // for(v=0;v<z.length;v++){
                 //   photos.push(z[v]);
               // }
                //photos.includes(value);
               // photos.push(z[0]);
                //console.log("PHOTOS");
                console.log("photos load:",photos);
            }
            console.log(props.listOfMarkers);
            //setError({ showError: true, message: y });
        }
        
    }
    function addPhotoToMarker(e:any,d:any){
        //check that the photo isn't already in the array. 
        console.log("file",e,"web",d);
        setFileName(e);
        setWebviewName(d);
        console.log("photos",photos);
    }
    //onload
    useIonViewWillEnter(() => {
        console.log('ionViewDidEnter event fired');
        loadLocation();
    });
    useEffect(() => {
        console.log(photos);
        console.log(selectMarker);
        //assign photos to another Array
      }, [photos]);
    function loadPhoto(x:any){
        if(x){
            console.log("x",x);
            console.log("Loadphoto:",x);
            console.log("length",x.length);
            
            photos.length = 0; //clear the temp photos gallery - load in saved photos
            var b = 0;
            for(b = 0; b < x.length; b++){
                photos.push(x[b]);
            }
            console.log("clear photos",photos);
            console.log(photos.length);

            if(photos.length === 0){
                setError({ showError: true, message: "No images found" });
                //why is this empty on some after adding it
            }else{
                setError({ showError: true, message: "Loading marker images" });
            }
        }else{
            
            photos.length = 0; //clear the temp photos gallery - load in saved photos
            var b = 0;
            for(b = 0; b < 0; b++){
                photos.push(x[b]);
            }
            console.log("clear photos",photos);

        }
    }
    function removeImage(x:any,y:any,z:any){
        //if it's the selected one remove it from the bubble
        console.log(x,y,z);
        var __FOUND = photos.findIndex(function(post, index) {
            if(post.webviewPath === x)
                return true;
        });

        console.log('found',__FOUND);

        if(__FOUND >= 0){
            if(webviewName === x){//remove the feature one if it is the one getting deleted
                setWebviewName(null);
                console.log('match');
                props.updateContent(selectField,selectText,selectMarker,props.markergroup,fileName,"",photos,props.markercolor);
            }else{
                props.updateContent(selectField,selectText,selectMarker,props.markergroup,fileName,webviewName,photos,props.markercolor);
            }
            console.log("webview:",webviewName,"x:",x)
            photos.splice(__FOUND,1); //remove it from the array
            deletePhoto(y); //removes it from filesystem
        }else{
            console.log("nofound");
        }
        console.log("WVN",webviewName);
        //
        //save 
        console.log(photos);
    }
    //photo
    //const { photo } = this.state;

  return (
        <>
        <IonLoading
          isOpen={loading}
          onDidDismiss={() => setLoading(false)}
          message={'Getting Location...'}
      />
      <IonToast
          isOpen={error.showError}
          position={'middle'}
          onDidDismiss={() => setError({ message: "", showError: false })}
          message={error.message}
          duration={3000}
      />
      <IonCol size="12" size-sm="6">
              
        <MapContainer 
        className="map" 
        //center={[latitude,longitude]} 
        center={props.mapCenter}
        tap={false}
        zoom={1} 
        scrollWheelZoom={false}
        >
            <LayersControl position="topright"><LayersControl.BaseLayer checked name="OpenStreetMap"
            ><TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                
                /></LayersControl.BaseLayer><LayersControl.BaseLayer name="Satellite Maps"><TileLayer
                attribution='&copy; <a href="http://osm.org/copyright">Mapbox</a> contributors'
                url="https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v9/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoidm9pbGFqb2huIiwiYSI6ImNrbWNjd3l6MDJhdjIydnFyZGRycTY5NDEifQ.POLhCsOl3z_p9LGn-36VnA"
                /></LayersControl.BaseLayer></LayersControl>
            <MyComponent 
            center={props.mapCenter}
            tap={false}
            zoom={13} />
            <LocationMarker/>
            <TileLayer 
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
           
            { props.listOfMarkers.map(
                (
                    mark: {
                        pos: any;
                        title: { rendered: string };
                        description: {rendered: string};
                        id: any;
                        fileid: any;
                        webid: any;
                        gallery: any;
                        color: any;
                    },
                    index: string | number | null | undefined
                    
                ) => (
                        <>
                        
                        <Marker 
                            key={index}
                            draggable={true}
                            position={mark.pos} 
                            icon={icon}
                            //ref = {mark.id}
                            eventHandlers={{
                                click: (e) => {
                                   //console.log("index",index);
                                    //console.log(e);
                                   setSelected(mark.title);//set the title
                                   setTextSelected(mark.description);//set the description
                                   setMarkerID(mark.id);
                                   setFileName(mark.fileid);
                                   setWebviewName(mark.webid);
                                   setSelectedImage(mark.fileid,mark.webid,mark.gallery);
                                   //console.log(mark.pos);
                                   loadPhoto(mark.gallery);
                                },
                                dragend: (e) => {
                                    console.log(e.target._latlng.lat);
                                    props.updatePosition(e.target._latlng.lat,e.target._latlng.lng,mark.id);
                                }
                                
                            }}>
                             <Popup minWidth={90}>
                                    
                                    <IonButton size="small" color="primary" className="trash" onClick={(e) => props.removeFromArray(mark.id)}><IonIcon icon={trash}></IonIcon></IonButton><br/>
                                    {(function() {
                                        if(mark.webid){
                                            return(
                                                <>
                                                <IonImg src={mark.webid} className="small-image"/>
                                                </>
                                            )

                                        }
                                    })()}
                                    
                                <strong>{selectField}</strong>
                                <p>{selectText}</p>
                              
                            </Popup>
                        </Marker>
                        </>
                )
            )} 
    </MapContainer>
    <IonButton color="primary" onClick={getLocation}>{"Get My Location"}</IonButton>
     <IonButton color="secondary" onClick={(e) => props.addMarker((getMapLat + (.0002 * props.markertotal)),(getMapLng + (.0002 * props.markertotal)),title,description,"","",props.markercolor)}>Add Marker</IonButton>
     <IonButton color="primary" onClick={() => history.replace("/explore/")}>{"Finish Exploration"}</IonButton>
    </IonCol>
              <IonCol size="12" size-sm="6">
                  <IonText className="details">
                    <IonItem>
                        <IonLabel position="stacked">Project Title</IonLabel><p>{props.markergroup}</p>
                    </IonItem>
                    <IonItem>
                        <IonLabel position="stacked">Marker Title</IonLabel>
                        <IonInput value={selectField}  type="text"  className="textfield" placeholder="" onIonChange={(e) => setSelected(e.detail.value!)}></IonInput>
                    </IonItem>
                    <IonItem>
                        <IonLabel position="stacked">The Description</IonLabel><IonInput value={selectText}  type="text"  className="textfield" placeholder="" onIonChange={(e) => setTextSelected(e.detail.value!)} ></IonInput>
                    </IonItem>
                    <IonItem>
                    <IonButton onClick={() => takePhoto()}>
                       Take Photo <IonIcon icon={camera}></IonIcon>
                    </IonButton>
                    
                    <IonButton color="secondary" onClick={(e) => props.updateContent(selectField,selectText,selectMarker,props.markergroup,fileName,webviewName,photos,props.markercolor)}>Save</IonButton>
                    
                    </IonItem>  
                    <IonContent>
                    <IonGrid style={{padding:'10px'}}>
                    <IonText className="greentext">To add a photo to your marker - select a photo from below, then select Save.</IonText>
                    <IonRow style={{padding:'10px'}}>

                    {photos.map((photo, index) => (
                        <IonCol>
                            <IonButton size="small" color="primary" className="trash" onClick={(e) => removeImage(photo.webviewPath,photo.filepath,index)}><IonIcon icon={trash}></IonIcon></IonButton>
                            <IonImg key={index} src={photo.webviewPath!} className={(photo.webviewPath! === webviewName) ? 'selected small-lower-image' : 'unselected small-lower-image'} onClick={(e)=>addPhotoToMarker(photo.filepath,photo.webviewPath)} />
                        </IonCol>
                        ))} 
                    </IonRow>
                    </IonGrid>
                    </IonContent>
                  </IonText>
                </IonCol>
                <PhotoGallery 
                    photos={photos}
                    setPhotos={setPhotos}
                />
        </>
  );
};
